<template>
  <v-card v-if="clickEnabled" @click="$emit('click', $event)">
    <slot></slot>
  </v-card>
  <v-card v-else>
    <slot></slot>
  </v-card>
</template>

<script>
export default {
  name: 'EsCard',
  props: {
    clickEnabled: {
      type: Boolean,
      default: false,
    },
  }
};
</script>
